import React, { useRef } from 'react'
import { orderbyDate } from '@helpers/helper.novelty'
import { useEffect, useState } from 'react'
import { Novelty, RealEstateDataPageComponentData } from 'types'
import { useGetBlogsQuery } from '@apis/mediacore/blog'
import { setActiveTags, setActiveNovelties } from '@slices/noveltiesSlice'
import { useDispatch, useSelector } from 'react-redux'
import { ElementHTML } from '@helpers/helper.rendering'
import { Col, Container, Row } from 'react-bootstrap'

const Main_Novelties_Jumbotron = (props: RealEstateDataPageComponentData) => {
  const dispatch = useDispatch()

  const {
    global_data: { id: siteId },
  } = props
  const { title, subtitle, titleElement } = props

  const { tags_active } = useSelector(
    (state: { novelties: { tags_active: number[]; novelties_active: Novelty[] } }) =>
      state.novelties,
  )!

  const { data: allBlogData, isLoading: _isLoadingNovelties } = useGetBlogsQuery({ site: siteId })

  const toggleTag = (id: number) => {
    const newTags = tags_active.includes(id)
      ? tags_active.filter((tagId) => tagId !== id)
      : [...tags_active, id]

    dispatch(setActiveTags(newTags))

    if (newTags.length === 0) {
      dispatch(setActiveNovelties(allBlogData?.news))
      return
    }

    const filtered = allBlogData?.news.filter((novelty) =>
      novelty.tags.some((tag) => newTags.includes(tag.id)),
    )
    dispatch(setActiveNovelties(filtered))
  }

  useEffect(() => {
    if (allBlogData?.news) {
      dispatch(setActiveNovelties(orderbyDate(allBlogData.news)))
    }
  }, [allBlogData])

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const handleClearFilters = () => {
    dispatch(setActiveTags([]))
    dispatch(setActiveNovelties(allBlogData?.news))
  }

  const [isMounted, setIsMounted] = useState(false)

  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)
  const buttonRef = useRef<HTMLDivElement>(null)

  const handleToggle = () => {
    setIsOpen((prev) => !prev)
  }

  const handleClickOutside = (e: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(e.target as Node) &&
      buttonRef.current &&
      !buttonRef.current.contains(e.target as Node)
    ) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    isMounted && (
      <section
        id="novelties-jumbotron"
        className="p-y-config novelties-jumbotron-5"
      >
        <Container fluid>
          <Row>
            <Col
              xs={12}
              lg={4}
            >
              <ElementHTML
                className={'mb-2'}
                children={title ?? 'Novedades'}
                elementType={titleElement || 'h2'}
              />
              {subtitle && <p>{subtitle}</p>}
            </Col>
            <Col
              xs={12}
              lg={8}
            >
              <div className="info-section d-lg-block  w-100 ">
                <div>
                  <div
                    className="d-lg-none d-flex content-filters"
                    ref={buttonRef}
                  >
                    <div
                      className="btn-filters-open w-auto"
                      onClick={handleToggle}
                    >
                      Filtros de busqueda <i className="icon-filters"></i>
                    </div>
                  </div>
                  <div className="d-lg-flex d-none align-items-center">
                    <div
                      className="btn-filters-open w-auto"
                      onClick={handleToggle}
                      ref={buttonRef}
                    >
                      Filtros <i className="icon-filters"></i>
                    </div>

                    <div className="p-2">
                      {tags_active.map((element, index) => (
                        <span
                          key={index}
                          className="custom-tag-button me-2 mb-2 mt-2 cursor-pointer"
                          onClick={() => toggleTag(element)}
                        >
                          {allBlogData?.tags.find((item) => item.id === element)?.name}
                        </span>
                      ))}
                    </div>

                    <div
                      className="btn btn-primary btn-filter"
                      onClick={handleClearFilters}
                    >
                      Limpiar filtros
                    </div>
                  </div>
                  {isOpen && (
                    <div
                      className={`custom-dropdown-menu p-4 mt-1`}
                      ref={dropdownRef}
                    >
                      <div className="d-flex justify-content-between">
                        <h5 className="font-weight-bold">Filtros:</h5>
                        <i
                          className="icon-close-light d-block d-lg-none"
                          onClick={() => setIsOpen(false)}
                        />
                      </div>

                      <hr className="divider" />
                      <div className="tag-container">
                        {allBlogData?.tags.map((tag, index) =>
                          tags_active.find((e) => e === tag.id) ? (
                            <button
                              className="me-2 mt-2 mt-lg-0 custom-tag-button custom-tag-button-active mb-2"
                              key={index}
                            >
                              {tag.name}
                            </button>
                          ) : (
                            <button
                              className="me-2 mt-2 mt-lg-0 custom-tag-button mb-2"
                              key={index}
                              onClick={() => toggleTag(tag.id)}
                            >
                              {tag.name}
                            </button>
                          ),
                        )}
                      </div>
                      <div
                        className="btn btn-primary btn-filter-mobile w-100 mt-3 d-block d-lg-none"
                        onClick={handleClearFilters}
                      >
                        Limpiar filtros
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    )
  )
}

export default Main_Novelties_Jumbotron
